import React from 'react'

export default function StartButton(props) {
    return <button onClick={props.click}>Start!</button>;
}